import React from 'react'
import { BusyButton } from '@ztechapps/webui.button'
import { useRole } from '@ztechapps/common.hook'
import { purchaseOrderPermissions } from '@ztechapps/purchase-order.common'

export const AddNewButton = ({ onClick }) => {
  const { hasRole } = useRole({ roleName: purchaseOrderPermissions.canEdit.value })
  return (
    <BusyButton
      {...{
        bsStyle: 'primary',
        icon: 'plus',
        onClick,
        text: 'Add New...',
        title: !hasRole ? 'You do not have permission to add new purchase order' : 'Add new purchase order.',
        disabled: !hasRole,
      }}
    />
  )
}
